import ClubPage from "./ClubPage";

export default ClubPage;
